import { StatCardProps } from './types';

export function StatCard({ icon, color, topTitle, topValue, bottomTitle, bottomValue, tooltip }: StatCardProps) {
  return (
    <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-5 relative flex flex-col justify-between min-h-[140px]">
      {/* Icon */}
      <div className="absolute top-4 right-4 text-2xl" style={{ color }}>
        {icon}
      </div>

      {/* Top Block */}
      <div>
        <div className="text-2xl font-bold text-neutral-900">{topValue}</div>
        <div className="text-sm text-neutral-500 flex items-center gap-1">
          {topTitle}
          {tooltip && (
            <span className="text-neutral-400 cursor-help" title={tooltip}>
              ⓘ
            </span>
          )}
        </div>
      </div>

      {/* Divider (optional, can be replaced by progress bar) */}
      <div className="my-3 h-px bg-neutral-200" />

      {/* Bottom Block */}
      <div className="flex justify-between items-center text-sm text-neutral-600">
        <span>{bottomTitle}</span>
        <span className="font-medium text-neutral-900">{bottomValue}</span>
      </div>
    </div>
  );
}
